import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get(`program-course-reference-identifier-types`)
}
